import type { PlanResponse } from "../../state/api.types";

export enum IneligibleReason {
  Inactive = "inactive",
  CircularDependency = "circular_dependency",
}

export type RenewalPlanOption = {
  uuid: string | null; // null for current plan
  name: string | null;
  state: string;
  renewalPlanUuid?: string | null;
  ineligibleReason?: IneligibleReason;
};

function wouldCreateCircularDependency(
  candidate: RenewalPlanOption,
  planUuid: string,
  allPlans: RenewalPlanOption[],
): boolean {
  const planMap = new Map(
    allPlans.filter((p) => p.uuid !== null).map((p) => [p.uuid!, p]),
  );
  const visited = new Set<string>();
  let current: string | null | undefined = candidate.renewalPlanUuid;
  while (current !== null && current !== undefined) {
    if (current === planUuid) return true;
    if (visited.has(current)) break;
    visited.add(current);
    current = planMap.get(current)?.renewalPlanUuid;
  }
  return false;
}

export function buildRenewalPlanOptions(
  plan: PlanResponse,
  plans: RenewalPlanOption[],
): RenewalPlanOption[] {
  const currentPlanItem: RenewalPlanOption = {
    uuid: null,
    name: "Current plan",
    state: plan.state,
  };

  const otherItems: RenewalPlanOption[] = plans
    .filter((p) => p.uuid !== plan.uuid)
    .map((p) => {
      if (p.state !== "active") {
        return { ...p, ineligibleReason: IneligibleReason.Inactive };
      }
      if (wouldCreateCircularDependency(p, plan.uuid, plans)) {
        return { ...p, ineligibleReason: IneligibleReason.CircularDependency };
      }
      return p;
    });

  return [currentPlanItem, ...otherItems];
}
